"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const AddDescriptionForm_1 = __importDefault(require("@Components/OverclaimView/DocumentForms/AddDescriptionForm"));
const EditUploadedDocumentsForm = ({ onSaveClicked, overlaimUploadedDocument }) => {
    const [updatedDescription, setUpdatedDescription] = (0, react_1.useState)(overlaimUploadedDocument.description || '');
    const { overclaimViewStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const params = (0, react_router_dom_1.useParams)();
    const overclaimHeaderId = params.overclaimHeaderId && +params.overclaimHeaderId;
    const updateDescription = () => __awaiter(void 0, void 0, void 0, function* () {
        if (updatedDescription && overclaimHeaderId) {
            yield overclaimViewStore.updateOverclaimDocumentDescription(overlaimUploadedDocument, updatedDescription);
        }
        onSaveClicked();
    });
    return (react_1.default.createElement("div", { className: 'upload-documentation-form' },
        react_1.default.createElement("h3", null, "Edit Document Description"),
        react_1.default.createElement("div", { className: "files-preview" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'file-item' },
                    react_1.default.createElement("div", { className: 'file-preview-name-container' },
                        react_1.default.createElement("b", null, overlaimUploadedDocument.name),
                        react_1.default.createElement("div", null,
                            Math.floor(overlaimUploadedDocument.size / 1000),
                            " KB"))),
                react_1.default.createElement(AddDescriptionForm_1.default, { setDescription: setUpdatedDescription, description: updatedDescription }))),
        react_1.default.createElement("div", { className: 'upload-files-button-container' },
            react_1.default.createElement(Button_1.Button, { className: 'done-button', mainColor: true, type: 'primary', onClick: updateDescription }, "Save"))));
};
exports.default = (0, mobx_react_1.observer)(EditUploadedDocumentsForm);
